import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="min-h-[500px] flex items-center justify-center bg-gray-50 my-8 rounded-lg shadow-sm">
      <div className="text-center px-4 py-12">
        <h1 className="text-8xl font-bold text-green-600 animate-bounce">404</h1>
        <div className="mt-4">
          <h2 className="text-2xl font-semibold text-gray-800 mb-2">頁面未找到</h2>
          <p className="text-gray-600 mb-8">抱歉，您要尋找的頁面不存在或已被移除。</p>
          <Link 
            to="./index.html" 
            className="inline-block bg-green-600 text-white px-6 py-3 rounded-lg hover:bg-green-700 transition-colors duration-300 shadow-md hover:shadow-lg"
          >
            返回首頁
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound; 